import React from "react";
import './App.css';
import IndicatorSummary from 'components/IndicatorSummary/IndicatorSummary';
import { getWindowParent } from 'lib/Utils';
import { isMobileDevice, MobileDeviceContext } from 'lib/Screen';

import * as am4core from "@amcharts/amcharts4/core";
import { HashRouter, Route, Routes } from "react-router-dom";
import RouteHandler from "components/RouteHandler/RouteHandler";

class App extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            mobileScreen: isMobileDevice()
        };

        this.resizeObserver = null;
    }

    componentDidMount() {
        am4core.options.queue = true;
        window.addEventListener("load", () => {
            if (window.self === window.top) return; // if w.self === w.top, we are not in an iframe 
            const send_height_to_parent_function = () => {
                var height = document.getElementsByTagName("html")[0].offsetHeight;
                console.log("Sending height as " + height + "px");
                const parent = getWindowParent();
                if (parent) {
                    parent.postMessage({ "height": height }, "*");
                }

                const isMobile = isMobileDevice();
                this.setState({
                    mobileScreen: isMobile
                });
            }
            // send message to parent about height updates
            send_height_to_parent_function(); //whenever the page is loaded
            window.addEventListener("resize", send_height_to_parent_function); // whenever the page is resized
            var observer = new MutationObserver(send_height_to_parent_function);           // whenever DOM changes PT1
            var config = { attributes: true, childList: true, characterData: true, subtree: true }; // PT2
            observer.observe(window.document, config);                                            // PT3 
        });
    }

    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(document.body);
            this.resizeObserver.disconnect();
        }
    }

    render() {

        return (
            <div id={process.env.NODE_ENV === 'development' ? "contentDev" : "contentProd"}>
                <MobileDeviceContext.Provider value={this.state.mobileScreen}>
                    <HashRouter>
                        <Routes>
                            <Route exact path='/' element={<IndicatorSummary />} />
                            <Route path='/detail' element={<RouteHandler />} />
                        </Routes>
                    </HashRouter>
                </MobileDeviceContext.Provider>
            </div>
        );
    }
}

export default App;
